import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paradontologija',
  templateUrl: './paradontologija.component.html',
  styleUrls: ['./paradontologija.component.css']
})
export class ParadontologijaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
